import type { TransportDto } from './api';

export function isCompletedTransport(transport: TransportDto) {
  return transport.status === 'closed'
    || transport.request_status === 'completed'
    || (transport.status === 'delivered' && Boolean(transport.customer_received_at));
}
